// Module
var code = "<p>[# connection-error] 无法获取到全节点的 websocket 连接</p> <p>Possible reasons: TODO</p> <ul> <li>reason #1</li> <li>reason #2</li> </ul> ";
// Exports
export default code;